import { createSlice } from "@reduxjs/toolkit";
import {
  createUserApis,
  excelClientWiseReportCountApis,
  reportListsApis,
  updatePasswordApis,
  userReportListsApis,
  usersApis,
} from "./reportActions";

const initialState = {
  userData: [],
  status: "idle",
  createStatus: "idle", // Added explicit initial state
  updatePasswordStatus: "idle", // Added explicit initial state
  error: null,

  // Overall / Detailed Query Report (reportListsApis)
  reportListData: null,

  // User Query Report (userReportListsApis) — kept in its OWN keys. Both
  // screens stay mounted as tabs, so sharing one key made whichever report
  // loaded last overwrite the other one's grid.
  userReportListData: null,
  userReportStatus: "idle",
  userReportError: null,
  // Id of the latest in-flight user-report request. Used to discard responses
  // from superseded requests so a slow/older result can't overwrite a newer one.
  userReportRequestId: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    logout(state) {
      return initialState; // Reset to initial state on logout
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users List
      .addCase(reportListsApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(reportListsApis.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.reportListData = action.payload?.data || action.payload;
      })
      .addCase(reportListsApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })

      .addCase(userReportListsApis.pending, (state, action) => {
        state.userReportStatus = "loading";
        state.userReportError = null;
        // Remember which request is the newest one in flight.
        state.userReportRequestId = action.meta.requestId;
      })
      .addCase(userReportListsApis.fulfilled, (state, action) => {
        // Ignore a stale response from a request that has since been superseded
        // (e.g. the date range / user was changed again before this returned).
        if (state.userReportRequestId !== action.meta.requestId) return;
        state.userReportStatus = "succeeded";
        state.userReportListData = action.payload?.data || action.payload;
      })
      .addCase(userReportListsApis.rejected, (state, action) => {
        if (state.userReportRequestId !== action.meta.requestId) return;
        state.userReportStatus = "failed";
        state.userReportError = action.payload || action.error.message;
      })

      .addCase(excelClientWiseReportCountApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(excelClientWiseReportCountApis.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.excelClientReporData = action.payload?.data || action.payload;
      })
      .addCase(excelClientWiseReportCountApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

export const { logout } = usersSlice.actions;
export default usersSlice.reducer;
